export const columns = [3, 3, 2, 2, 1];
